import React from "react";
import styled from "styled-components";
import { space, SpaceProps } from "styled-system";
import Flex from "./Flex";
import Text from "./Text";

const Container = styled.div<SpaceProps>`
  border: 1px solid ${(props) => props.theme.colors.border};
  background-color: ${(props) => props.theme.colors.surface};
  display: flex;
  justify-content: space-between;
  border-radius: ${(props) => props.theme.borderRadius.md}px;
  height: auto;
  padding: 18px;
  align-items: center;
  ${space};
`;

export type FormColorInputProps = {
  label: string;
  subLabel: string;
  value: string | null;
  onChange: (value: string | null) => void;
} & SpaceProps;

export const FormColorInput = ({
  value,
  label,
  subLabel,
  onChange,
  ...rest
}: FormColorInputProps) => {
  return (
    <Container {...rest}>
      <Flex flexDirection="column">
        <Text fontWeight={500}>{label}</Text>
        {subLabel && (
          <Text fontSize={2} color="grey2">
            {subLabel}
          </Text>
        )}
      </Flex>
      <input
        type="color"
        value={value ?? ""}
        onChange={(ev) => onChange(ev.target.value)}
      />
    </Container>
  );
};
